
import { Link } from "react-router-dom";
import "../../assets/css/pte-responsive.css";
import SkillCard from "components/Frontend/SkillCard";


const WhyChoose = (props) => {
    const { whyChooseSectionHeader } = props;
    return (
        <div className="choice-ielts">
            <div className="container">
                <div className="row">
                    {whyChooseSectionHeader && whyChooseSectionHeader()}
                    <div className="plan-cards d-none d-md-flex">
                        <div className="plan-card-outer">
                            <div className="plan-card">
                                <div className="icon-wrapper">
                                    <svg
                                        width="18"
                                        height="14"
                                        viewBox="0 0 18 14"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M17 1.49072L6 12.4907L1 7.49072"
                                            stroke="#48A75C"
                                            strokeWidth="1.8"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>
                                <div className="content-wrapper p-0">
                                    <h2>Faster Results</h2>
                                    <p>
                                        Get your test results within 24 hours, ensuring timely
                                        progress toward your goals.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="plan-card-outer">
                            <div className="plan-card">
                                <div className="icon-wrapper">
                                    <svg
                                        width="18"
                                        height="14"
                                        viewBox="0 0 18 14"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M17 1.49072L6 12.4907L1 7.49072"
                                            stroke="#48A75C"
                                            strokeWidth="1.8"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>
                                <div className="content-wrapper p-0">
                                    <h2>Unbiased Scoring</h2>
                                    <p>
                                        AI-powered evaluation guarantees consistent and accurate
                                        scoring every time.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="plan-card-outer">
                            <div className="plan-card">
                                <div className="icon-wrapper">
                                    <svg
                                        width="18"
                                        height="14"
                                        viewBox="0 0 18 14"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M17 1.49072L6 12.4907L1 7.49072"
                                            stroke="#48A75C"
                                            strokeWidth="1.8"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>
                                <div className="content-wrapper p-0">
                                    <h2>Flexible Scheduling</h2>
                                    <p>
                                        Year-round test availability and global centers for your
                                        convenience.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="plan-card-outer">
                            <div className="plan-card">
                                <div className="icon-wrapper">
                                    <svg
                                        width="18"
                                        height="14"
                                        viewBox="0 0 18 14"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M17 1.49072L6 12.4907L1 7.49072"
                                            stroke="#48A75C"
                                            strokeWidth="1.8"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>
                                <div className="content-wrapper p-0">
                                    <h2>Digital Format</h2>
                                    <p>
                                        Designed for tech-savvy students, the computer-based
                                        approach simplifies navigation.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="plan-card-outer">
                            <div className="plan-card">
                                <div className="icon-wrapper">
                                    <svg
                                        width="18"
                                        height="14"
                                        viewBox="0 0 18 14"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M17 1.49072L6 12.4907L1 7.49072"
                                            stroke="#48A75C"
                                            strokeWidth="1.8"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>
                                <div className="content-wrapper p-0">
                                    <h2>Global Recognition</h2>
                                    <p>
                                        Accepted by leading academic institutions and
                                        immigration authorities worldwide.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row align-items-center d-flex">
                    <div className="col-md-7">
                        <p className="light-blue-box m-0">
                            Don't let outdated testing systems slow you down, embrace the
                            PTE's modern, efficient format to align with your education or
                            residency goals.
                        </p>
                    </div>
                    <div className="col-md-5 text-center text-md-end">
                        <Link className="primary-btn" to="/auth/register">
                            <span className="btn-inner">
                                REGISTER FOR YOUR PTE PREPARATION COURSE TODAY
                                <img
                                    src="/images/web-new-images/right-arrow.svg"
                                    alt="Register Now"
                                />
                            </span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WhyChoose;





